module.exports = __webpack_public_path__ + "img/icon-error.86fb12f9.svg";